import { MenuItem, Select } from '@mui/material';
import { useMemo } from 'react';
import {
  configurationV21SelectMenuProps,
  parseConfigurationValuesList,
} from './configurationV21ListFieldUtils';

interface ConfigurationOptionListValueFieldV21Props {
  handleValueChange: (val: string) => void;
  controlerValue: string;
  valuesList: string;
}

export const ConfigurationOptionListValueFieldV21: React.FC<
  ConfigurationOptionListValueFieldV21Props
> = ({ handleValueChange, controlerValue, valuesList }) => {
  const dropdownValuesList = useMemo(
    () => parseConfigurationValuesList(valuesList),
    [valuesList]
  );

  const selectValue = useMemo(() => {
    if (controlerValue && dropdownValuesList.includes(controlerValue)) {
      return controlerValue;
    }
    return '';
  }, [controlerValue, dropdownValuesList]);

  return (
    <Select
      value={selectValue}
      onChange={(e) => {
        handleValueChange(e.target.value as string);
      }}
      displayEmpty
      renderValue={() => {
        if (controlerValue) {
          return controlerValue;
        }
        return '-';
      }}
      fullWidth
      MenuProps={configurationV21SelectMenuProps}
      sx={{
        minWidth: 0,
        maxWidth: '100%',
        '& .MuiSelect-select': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
      }}
    >
      {dropdownValuesList.map((listItemValue) => (
        <MenuItem key={listItemValue} value={listItemValue}>
          {listItemValue}
        </MenuItem>
      ))}
    </Select>
  );
};
